module.exports = __webpack_public_path__ + "static/media/GTD-mobile-logo.a7198675.svg";